/**
 * The how-to registry. `/how-to` and `/how-to/<slug>` — v1's own addresses.
 */

import type { ContentLang } from "@fazly/shared/contentLang";

import { en } from "./en";
import type { HowtoBundle, HowtoSlug } from "./types";
import { HOWTO_SLUGS } from "./types";

export function howtoPath(slug: HowtoSlug, lang: ContentLang = "en"): string {
  return lang === "en" ? `/how-to/${slug}` : `/${lang}/how-to/${slug}`;
}

export function howtoIndexPath(lang: ContentLang = "en"): string {
  return lang === "en" ? "/how-to" : `/${lang}/how-to`;
}

export function howtoSlugOf(raw: string): HowtoSlug | null {
  return (HOWTO_SLUGS as readonly string[]).includes(raw)
    ? (raw as HowtoSlug)
    : null;
}

const LOADERS: Record<ContentLang, () => Promise<HowtoBundle>> = {
  en: async () => en,
  de: () => import("./de").then((m) => m.de),
  tr: () => import("./tr").then((m) => m.tr),
  pt: () => import("./pt").then((m) => m.pt),
  es: () => import("./es").then((m) => m.es),
};

export function loadHowto(lang: ContentLang): Promise<HowtoBundle> {
  return LOADERS[lang]();
}

export type { HowtoBundle, HowtoSlug };
export { HOWTO_SLUGS };
